import './context-menu.css';

import { ClickedOutside } from '../clicked-outside/clicked-outside';

export function ContextMenu(props) {
    const close = () => {
        if (props.closed) {
            props.closed();
        }
    };

    const open = props.open ? "open" : "";
    const align = props.align || "";

    const className = props.class || "";

    return (
        <ClickedOutside clickedOutside={() => close()}>
            <div className={`context-menu ${open} ${className}`} align={align}>
                {props.children}
                {props.open &&
                    <div className="context-menu-content">
                        {props.content}
                    </div>
                }
            </div>
        </ClickedOutside>
    );
}